export default __webpack_public_path__ + "static/media/create-new.d5617e45.svg";